<template>
  <div class="widget-empty-state" :class="'is-' + tone" role="status">
    <span class="widget-empty-state__icon" aria-hidden="true">
      <AppIcon :icon="icon" :weight="500"></AppIcon>
    </span>
    <div class="widget-empty-state__content">
      <span class="widget-empty-state__label">{{ label }}</span>
      <p>{{ message }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    message: { type: String, default: '' },
    variant: { type: String, default: 'warning' },
  },
  computed: {
    tone() {
      if(this.variant === 'danger') return 'danger'
      if(this.variant === 'success') return 'success'
      return 'info'
    },
    icon() {
      if(this.tone === 'danger') return 'exclamation-circle'
      if(this.tone === 'success') return 'check2-circle'
      return 'info-circle'
    },
    label() {
      if(this.tone === 'danger') return 'Requiere atención'
      if(this.tone === 'success') return 'Todo al día'
      return 'Sin novedades'
    },
  },
}
</script>

<style>
.widget-empty-state {
  position: relative;
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 76px;
  margin: 0;
  padding: 14px 16px;
  overflow: hidden;
  border: 1px solid var(--app-color-info-border);
  border-radius: 10px;
  background: var(--app-color-info-soft);
  color: var(--app-color-text-secondary);
}
.widget-empty-state::before {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 4px;
  background: var(--app-color-info);
  content: '';
}
.widget-empty-state__icon {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: var(--app-color-info);
  color: var(--app-color-on-primary);
  font-size: 1.1rem;
}
.widget-empty-state__content { min-width: 0; }
.widget-empty-state__label {
  display: block;
  margin-bottom: 3px;
  color: var(--app-color-text);
  font-size: var(--app-text-xs);
  font-weight: var(--app-font-semibold);
  letter-spacing: .035em;
  text-transform: uppercase;
}
.widget-empty-state p {
  margin: 0;
  color: var(--app-color-text-secondary);
  font-size: var(--app-text-sm);
  line-height: var(--app-leading-default);
}
.widget-empty-state.is-success { border-color: var(--app-color-success-border); background: var(--app-color-success-soft); }
.widget-empty-state.is-success::before { background: var(--app-color-success); }
.widget-empty-state.is-success .widget-empty-state__icon { background: var(--app-color-success); }
.widget-empty-state.is-danger { border-color: var(--app-color-danger-border); background: var(--app-color-danger-soft); }
.widget-empty-state.is-danger::before { background: var(--app-color-danger); }
.widget-empty-state.is-danger .widget-empty-state__icon { background: var(--app-color-danger); }
</style>
